import { links, Request } from '@app/client';
import { type ApiResult, type BaseParams, type PostParams, type ResourceId, type Token } from '@app/client/common';
export async function getToken(
    params: BaseParams & PostParams<{ bypass_two_factor: boolean }> & { id: ResourceId },
): Promise<ApiResult<Token>> {
    return Request.postRequest<Token>({
        ...params,
        target: links.admin().auth(params.id).token(),
        settings: {
            ...params.settings,
        },
    });
}

export async function disable2FA(
    params: BaseParams & PostParams & { id: ResourceId },
): Promise<ApiResult<{ message: string }>> {
    return Request.deleteRequest<{ message: string }>({
        ...params,
        target: links.admin().auth(params.id).twoFactorAuth().disable(),
        settings: {
            ...params.settings,
        },
    });
}

export async function getStatus(params: BaseParams): Promise<ApiResult<{ status: string }>> {
    return Request.getRequest<{ status: string }>({
        ...params,
        target: links.status(),
        settings: {
            ...params.settings,
        },
    });
}

export const authCalls = {
    getToken,
    disable2FA,
    getStatus,
};
